import React from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { rst } from 'rt-state';
import { FieldProps, FormValues, GenericProps, onDefaultChange } from '../../commons';
import { nameToLabel, transError, transLabel } from '../../commons';

export type XTextFieldProps<Values extends FormValues = FormValues> = GenericProps<TextFieldProps, Values> & {
    asterisk: boolean;
};

const DEFAULT_PROPS = {
    fullWidth: true,
    margin: 'normal',
    variant: 'outlined',
    size: 'small',
} as Partial<XTextFieldProps>;

export const XTextField = rst.createS<FieldProps & Partial<XTextFieldProps>>((props) => {
    const { form, name: fieldName, asterisk, ...otherProps } = props;
    const { touched, errors, values, fieldProps } = form;
    const { label = nameToLabel(fieldName), onChange, helperText, ...other } = {
        ...DEFAULT_PROPS,
        ...otherProps,
        ...fieldProps[fieldName],
    } as XTextFieldProps;
    const fieldValue = values[fieldName];
    const error = errors[fieldName];
    const touchedVal = touched[fieldName];
    const hasError = touchedVal && error !== undefined;
    const labelNode = asterisk ? (
        <div>
            <span style={{ color: 'red' }}>*</span>&nbsp;&nbsp;
            {transLabel(label)}
        </div>
    ) : (
        transLabel(label)
    );
    return (
        <TextField
            label={labelNode}
            error={hasError}
            helperText={hasError ? transError(error) : helperText}
            name={fieldName}
            onChange={(e) => {
                onDefaultChange(e.target.value, fieldName, props.form, onChange).then();
            }}
            value={fieldValue}
            {...(other as any)}
        />
    );
});
